import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

export default class CookieConcentBtn extends Component {
  handleCookieConsentClick = async () => {
    if (typeof window !== 'undefined') {
      if (window.Optanon) {
        window.Optanon.ToggleInfoDisplay();
      }
    }
  };

  render() {
    const styles = {
      dc_cookie_consent:
        'fixed right-10 bottom-0 z-50 cursor-pointer text-black border-white-solid-2 bg-white p-10 border-solid border-1 border-black font-HelveticaNeueMedium  text-12 text-darkyellow rounded cookie-consent',
    };
    const { locale, enabled, href } = this.props;
    const i18nMessages = require(`../../../constants/messages/${locale}`);
    return enabled ? (
      <Fragment>
        <a
          className={styles.dc_cookie_consent}
          href={href}
          onClick={this.handleCookieConsentClick}
          title={i18nMessages.cookieConsent}
        >
          {i18nMessages.cookieConsent}
        </a>
      </Fragment>
    ) : (
      ''
    );
  }
}

CookieConcentBtn.propTypes = {
  enabled: PropTypes.bool.isRequired,
  locale: PropTypes.string.isRequired,
  href: PropTypes.string.isRequired,
};
